import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../../user/user-subscription";
import {ChosenPlan} from "../../../../../payment-info/models/plan.model";
import {GoogleAnalyticsService} from "../../../../../../services/google-analytics/google-analytics.service";
import {OneMonthFreeStep} from "../../../one-month-free.component";
import {TextUtils} from "../../../../../../utils/text-utils";


@Component({
    selector: 'db-one-week-free-demo-option',
    templateUrl: './one-week-free-demo-option.component.html',
    styleUrls: ['./one-week-free-demo-option.component.scss'],
    standalone: false
})
export class OneWeekFreeDemoOptionComponent implements OnInit, OnDestroy {
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  @Output() onPlanChange = new EventEmitter<ChosenPlan>();
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();

  @Input() isEcommerceWebsite: boolean = false;
  @Input() isAgency: boolean = false;
  @Input() mostPopular: boolean = false;
  @Input() paidFeature?: boolean = false;
  @Input() title: string;
  @Input() activeTab: string;
  @Input() domainName?: string;
  @Input() description: string = null;
  @Input() planDesc: string = null;
  @Input() plan: string[];
  @Input() subscription: UserSubscription;
  @Input() periodSwitchValue: number = 12;
  @Input() professionalInfo: boolean;
  @Input() applyCouponForPlatform?: boolean;
  @Input() couponPercent?:  number = 0;
  @Input() hasFreeDays: boolean = false;
  @Input() customDomainFlow?: boolean;
  @Input() isBlkOffer?: boolean;
  isMobile: boolean = false;
  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  public replaceParam(string, params: any = null): string {
    return TextUtils.getText(null, params, string);
  }

  public chooseSubscr(subscription: UserSubscription) {
    const chosenPlan: ChosenPlan = {
      id: subscription.id,
      title: subscription.plan.title,
      price: subscription.plan.planPrice,
      type: this.periodSwitchValue === 12 ? 'year' : 'month'
    };
    this.onPlanChange.emit(chosenPlan);
    this._sendEvent(chosenPlan);
  }

  private _sendEvent(chosenPlan): void {
    const analyticsData = {
      eventCategory: 'Dashboard Pageview',
      eventAction: 'Checkout Page visit (1wf pop-up)',
      eventLabel: chosenPlan.title + ' ' + chosenPlan.type + 'ly'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
